import { Box, Divider, Tab, Tabs, Typography } from "@mui/material"
import { ChevronRightOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import { OPPORTUNITY_PIPELINE_TAB } from "../constants"

import { NewRequestDialog } from "./NewRequestDialog/NewRequestDialog"

import { Button } from "@/components/common/Button"
import SearchInput from "@/components/SearchInput/SearchInput"

export const SalesMobilePage: FC = () => {
  const [isNewRequestOpen, setIsNewRequestOpen] = useState(false)

  return (
    <Box className='flex h-full flex-col gap-y-4 p-4'>
      <Typography variant='h5' className='font-normal text-gray-900'>
        Sales
      </Typography>

      <Box>
        <Tabs value={OPPORTUNITY_PIPELINE_TAB}>
          <Tab label='Opportunity Pipeline' value={OPPORTUNITY_PIPELINE_TAB} />
        </Tabs>
        <Divider />
      </Box>

      <SearchInput
        placeholder='Search by Company Name, ID'
        className='w-full'
        data-testid='sales.mobile-page.search-field'
      />

      <Button
        appearance='contained'
        endIcon={<ChevronRightOutlined />}
        onClick={() => setIsNewRequestOpen(true)}
        className='w-full'
        data-testid='sales.mobile-page.start-request-button'
      >
        Start Request
      </Button>

      {isNewRequestOpen && <NewRequestDialog fullScreen onClose={() => setIsNewRequestOpen(false)} />}
    </Box>
  )
}
